export default __webpack_public_path__ + "static/media/review-4.1ac70573.png";